import { Props } from "../../../types";
import { classNameParser } from "../../../helpers";

import "./style.css";

export const CardBox = (props: Props) => (
  <div className={classNameParser("card-box", props.className)} style={props.style} id={props?.id}>
    {props.children}
  </div>
);
